import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "../../__root";

export const usersPasswordEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/users/password/edit",
  component: lazyRouteComponent(
    () =>
      import(
        /* webpackChunkName: "ChangePasswordPage" */ "@circle-react/components/OnboardingPage/ChangePasswordPage"
      ),
    "ChangePasswordPage",
  ),
});
